import React, { useEffect, useState } from 'react'

import DefaultEntityCrud from 'components/form/DefaultEntityCrud'
import FormContent from 'components/form/FormContent'
import FormRow from 'components/form/FormRow'
import SelectInput from 'components/form/input/SelectInput'
import TextInput from 'components/form/input/TextInput'

import SeletorCliente from 'entity/Cliente/components/SeletorCliente'
import Fazenda from 'entity/Fazenda'

import { DebugConsole } from './debugg'
import BotoesForm from './BotoesForm'
import DialogLoading from './DialogLoading'
import { usePerfil } from 'useAuth'
import { useNavigate } from 'react-router-dom'
import useNotification from 'notification'
import TabelaTalhoes from './TabelaTalhoes'

function FazendaFormInter(props) {
    const { values, form: { change, } } = props
    const { talhoesFazenda } = values
    const [loadingCSV, setLoadingCSV] = useState(-1)
    const navigate = useNavigate()
    const { showSuccess } = useNotification()

    const perfil = usePerfil()
    let tipoPerfil = 'cliente'
    if (perfil) {
        if (perfil.grupoPermissao) {
            if (perfil.grupoPermissao.uid === "r9jrEQXznNgjrZTGCfch") {
                tipoPerfil = 'admin'
            }
            if (perfil.grupoPermissao.uid === "RECT03jkyTQW9B2OMz47") {
                tipoPerfil = 'tecnico'
            }
            if (perfil.grupoPermissao.uid === "-OXwisN4fkQV3l7Uzeui") {
                tipoPerfil = 'lider'
            }
        }
    }

    useEffect(() => {
        if (talhoesFazenda) {
            let areaTotal = 0;
            talhoesFazenda.forEach(item => {
                if (!isNaN(item.area)) {
                    areaTotal += Number(item.area)
                }
            })
            change("areaTotalFazenda", areaTotal.toFixed(2))
        }
    }, [change, talhoesFazenda]);

    return (
        <FormContent sx={{ p: 2 }}>
            <DebugConsole values={values} />
            {tipoPerfil === 'admin' || loadingCSV !== -1 ? <BotoesForm change={change} setLoadingCSV={setLoadingCSV} navigate={navigate} showSuccess={showSuccess} /> : ''}
            {loadingCSV !== -1 ? <DialogLoading loadingCSV={loadingCSV} /> : ""}
            <FormRow sx={{ gap: 3 }}>
                <SelectInput
                    sx={{ flex: 0.2 }}
                    name="status"
                    label="Status"
                    options={["ATIVO", "INATIVO"]}
                    required
                />
                <TextInput name="codFazenda" label="Cód. Fazenda" required sx={{ flex: 0.5 }} />
                <SeletorCliente required />
                <TextInput name="nomeFazenda" label="Nome Fazenda" required />
            </FormRow>
            <FormRow sx={{ gap: 3 }}>
                <TextInput name="enderecoFazenda" label="Endereço" required />
                <TextInput name="cidadeFazenda" label="Cidade" required />
                <SelectInput
                    sx={{ flex: 0.2 }}
                    name="estadoFazenda"
                    label="Estado"
                    options={[
                        'AC',
                        'AL',
                        'AP',
                        'AM',
                        'BA',
                        'CE',
                        'DF',
                        'ES',
                        'GO',
                        'MA',
                        'MS',
                        'MT',
                        'MG',
                        'PA',
                        'PB',
                        'PR',
                        'PE',
                        'PI',
                        'RJ',
                        'RN',
                        'RS',
                        'RO',
                        'RR',
                        'SC',
                        'SP',
                        'SE',
                        'TO',
                    ]}
                    required
                />
                <TextInput name="areaTotalFazenda" label="Área Total" disabled />
            </FormRow>
            <FormRow>
                <TabelaTalhoes areaCultivada={props.values} />
            </FormRow>
        </FormContent>)
}

export default function FazendaForm() {

    return (
        <DefaultEntityCrud
            title={"Cadastro de Fazenda"}
            EntityClass={Fazenda}
            routeForm={"_fazenda"}
            backRoute="consulta-fazenda"

            formActions={{ novoForm: false, salvarForm: true, sairForm: true }}
        >
            {(props) => <FazendaFormInter {...props} />}
        </DefaultEntityCrud>
    )
}
